<template>
  <div>
    <a-modal modal-id="create-statement">
      <div slot="title">Create Statement</div>
      <div slot="form">
        <div class="row m-b-sm">
          <label for="name">Name</label>
          <input type="text" id="name" class="form-control" v-model="statement['name']">
        </div>
        <div class="row m-b-sm">
          <label for="period">Period</label>
          <input type="date" id="period" class="form-control" v-model="statement['startDate']" placeholder="From">
          <input type="date" class="form-control" v-model="statement['endDate']" placeholder="To">
        </div>
        <div class="row m-b-sm">
          <label for="name">Prebuild</label>
          <v-select :options="['domains', 'hosting']" multiple v-model="statement['prebuild']"></v-select>
        </div>
        <div class="row m-b-sm">
          <button class="btn btn-xs btn-primary" @click="addStatement"><i class="fa fa-plus"></i> Create</button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import axios from 'axios'
import { eventBus } from '../../../../../../main'

export default {
  data () {
    return {
      statement: {}
    }
  },
  props: ['client'],
  methods: {
    addStatement () {
      console.log(this.client)
      axios.post('/billing/statement', {client: this.client, ...this.statement})
        .then(r => {
          $('#create-statement').modal('hide')
          this.statement = {}
          eventBus.$emit('reloadStatements')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Tabs/Statements/StatementModal.vue